import { PageBlock } from '@design-system/page-block';
import React, { forwardRef, useEffect } from 'react';

import { IframeProps } from './models';
import {
  onMessageReceive,
  postUtmParamsToIframe,
  queryForHeight,
} from './utils';

const Iframe = forwardRef<HTMLDivElement, IframeProps>(
  (
    {
      pageBlockUI,
      componentId,
      title,
      name,
      height,
      width,
      src,
      sandbox: { allowances },
      allow: { flags },
      referrerpolicy,
      uid,
      onLoadCallbackDelay = 500,
    },
    ref
  ) => {
    const id = 'iframe';
    const onLoad = () => {
      setTimeout(() => {
        postUtmParamsToIframe(id);
      }, onLoadCallbackDelay);
    };

    useEffect(() => {
      const createOnMessage = (event) => {
        onMessageReceive(event, id);
      };

      const createOnresize = () => {
        queryForHeight(id);
      };

      queryForHeight(id);

      window.addEventListener('message', createOnMessage);
      window.addEventListener('resize', createOnresize);

      return () => {
        window.removeEventListener('message', createOnMessage);
        window.removeEventListener('resize', createOnresize);
      };
    }, [id]);

    return (
      <PageBlock
        {...pageBlockUI}
        id={componentId}
        className="iframe-container"
        componentUid={uid}
        ref={ref}
      >
        <iframe
          id={id}
          data-testid={id}
          title={title}
          name={name}
          height={height}
          width={width}
          src={src}
          sandbox={allowances.join(' ')}
          allow={flags.length ? flags.join('; ') : undefined}
          referrerPolicy={referrerpolicy}
          onLoad={onLoad}
        />
      </PageBlock>
    );
  }
);

export default Iframe;
